import {
    CANNEDCOMMAND_DELETE_OPEN_MODAL,
    CANNEDCOMMAND_DELETE_REQUEST,
    CANNEDCOMMAND_DELETE_RESULT,
} from 'Redux/actionTypes';

export const cannedCommandDeleteOpenModal = (data) => ({
    type: CANNEDCOMMAND_DELETE_OPEN_MODAL,
    payload: data,
})

export const cannedCommandRequest = (data) => ({
    type: CANNEDCOMMAND_DELETE_REQUEST,
    payload: data,
})

export const cannedCommandResult = (result) => ({
    type: CANNEDCOMMAND_DELETE_RESULT,
    payload: result
})